import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note17',
  templateUrl: './note17.component.html',
  styleUrls: ['./note17.component.scss'],
})
export class Note17Component implements OnInit {
  note17Form: FormGroup;
  calculativeDate: any;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note17) {
        this.calculativeDate = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes17(data.response.userInputData.data);
        }
      }
    });
  }
  editNotes17(res): void {
    this.note17Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
    });
  }

  setForm(): void {
    this.note17Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
